module.exports = __webpack_public_path__ + "static/media/discord.cc8afd29.svg";